import {
    HOLES_INDEX_PAR_LOADING,
    HOLES_INDEX_PAR_SUCCESS,
    HOLES_INDEX_PAR_ERROR,
    CLEAR_HOLES_INDEX_PAR,
} from "../../../constant/actionTypes";

const getCourseParIndex = (state = {}, action) => {
    switch (action.type) {
        case HOLES_INDEX_PAR_LOADING: {
            let obj = {
                loading: true,
            };
            return obj;
        }
        case HOLES_INDEX_PAR_SUCCESS: {
            let obj = {
                loading: false,
                status: action.response,
            };
            return obj;
        }
        case HOLES_INDEX_PAR_ERROR: {
            let obj = {
                loading: false,
                status: action.response,
            };
            return obj;
        }
        case CLEAR_HOLES_INDEX_PAR: {
            let obj = {};
            return obj;
        }
        default:
            return state;
    }
};

export default getCourseParIndex;
